module.exports = __webpack_public_path__ + "img/hyper_logo.8787e083.png";